<template>
  <div>
    <c-box
      :loading="loading"
      shadow
    >
      <table
        v-if="!loading && data.length"
        class="table"
      >
        <thead>
          <tr>
            <th>Адрес страницы</th>
            <th>Визиты</th>
            <th>Доля в общем числе визитов, %</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in data"
            :key="item.Запрос"
          >
            <td v-text="item.Запрос" />
            <th v-text="item.Визиты" />
            <th
              class="text-success"
              v-text="item.ДоляВОбщемЧислеВизитов + '%'"
            />
          </tr>
        </tbody>
      </table>
      <no-data v-if="!loading && !data.length" />
    </c-box>

    <p
      v-if="conclusion"
      v-html="conclusionHtml"
    />
  </div>
</template>

<script>
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import { conclusion1CToHtml } from '../../../../../../../resources/js/helper'
import NoData from '../../../../../../../resources/js/components/NoData.vue'

export default {
  name: 'VisitsByUrl',
  components: { NoData, CBox },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    conclusion: {
      type: String,
      required: true
    }
  },
  computed: {
    conclusionHtml () {
      return conclusion1CToHtml(this.conclusion)
    }
  }
}
</script>
